import { client } from '@api/client';

import { TEmptyObject } from '@interfaces/common/common';
import { TEditOrganisationProfile } from '@interfaces/organisation/dto/organisationsDTO';
import { IOrganisationEntity } from '@interfaces/organisation/organisations';

import { URL } from './urls';

const {
	organizationProfileByUser,
	organizationsEditByUser,
} = URL;

export const getByUserOrganisationProfile = (): Promise<IOrganisationEntity | TEmptyObject> => {
	return client.get(`/${organizationProfileByUser}`);
};

export const editByUserOrganisationProfile = ({
	id, values,
}: TEditOrganisationProfile): Promise<void> => client.put(`/${organizationsEditByUser}/${id}`, {
	...values,
});
